import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.REACT_APP_PUSHER_KEY,             // same as PUSHER_APP_KEY
  cluster: process.env.REACT_APP_PUSHER_CLUSTER || 'eu',
  forceTLS: true,
  encrypted: true,
  // DO NOT override wsHost/wsPort when using Pusher cloud
  authEndpoint: 'https://plateformewmg.cloud/broadcasting/auth',
  auth: {
    headers: {
      Accept: 'application/json',
      // add Authorization header here if your broadcasting routes require auth
      // Authorization: `Bearer ${token}`,
    },
  },
});

export default echo;